import { createApp } from 'vue'
import router from './router'
import { Chart, registerables } from 'chart.js'
import 'chartjs-adapter-date-fns'
import '@popperjs/core'
import 'bootstrap/dist/js/bootstrap.esm'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

import { initI18n, loadI18nMessages } from './i18n'
import { setupTitle } from './shared/use-title'
import App from './App'
import './style.css'

Chart.register(...registerables)

setupTitle({ suffix: 'F4C' })

const { vueI18n } = initI18n()

loadI18nMessages(vueI18n)
  .then(() => {
    const app = createApp(App)
      .use(router)
      .use(vueI18n)
    app.mount('#app')
  })
